import React, { useState } from 'react';
import { KissFile, KissFileOverlay } from '@99designs/feature-file-overlay';
import Sidebar from './Sidebar';
import { Designer } from './types';
import useImagePreloader from './useImagePreloader';

interface ProfileOverlayProps {
    designer: Designer;
    pitch?: string;
    jobId?: string;
    onClose: () => void;
    onSelectDesigner: () => void;
    selectedDesignIndex: number;
    onDesignChange: (index: number) => void;
}

function ProfileOverlay(props: ProfileOverlayProps) {
    const {
        designer,
        pitch,
        jobId,
        onClose,
        selectedDesignIndex,
        onDesignChange,
        onSelectDesigner,
    } = props;
    const [showFileOverlay, setShowFileOverlay] = useState(true);
    const totalFilesCount = designer.profile.designs.length;
    const {
        id,
        imageSources: { original },
    } = designer.profile.designs[selectedDesignIndex];
    const file: KissFile = {
        id: id.toString(),
        previewUrl: original,
        width: 600,
        height: 600,
        downloadUrl: original,
        isGeneratedPreview: false,
        isDeleted: false,
    };

    useImagePreloader(
        designer.profile.designs.map((d) => ({
            id: d.id.toString(),
            url: d.imageSources.mediaCrop,
        }))
    );

    const prev = () => {
        if (selectedDesignIndex - 1 >= 0) {
            onDesignChange(selectedDesignIndex - 1);
        }
    };

    const next = () => {
        if (selectedDesignIndex + 1 < totalFilesCount) {
            onDesignChange(selectedDesignIndex + 1);
        }
    };

    const closeFileOverlay = () => {
        setShowFileOverlay(false);
        onClose();
    };

    return (
        <KissFileOverlay
            showFileOverlay={showFileOverlay}
            file={file}
            currentFileIndex={selectedDesignIndex}
            totalFilesCount={totalFilesCount}
            nextFile={next}
            previousFile={prev}
            closeOverlayHandler={closeFileOverlay}
            sidebarComponent={
                <Sidebar
                    designer={designer}
                    pitch={pitch}
                    jobId={jobId}
                    onSelectDesigner={onSelectDesigner}
                    closeOverlayHandler={closeFileOverlay}
                />
            }
        />
    );
}

export default ProfileOverlay;
